import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import authService from '../services/authService';
import { User } from '../types';
import './Navbar.css';

interface NavbarProps {
  isAuthenticated: boolean;
  user: User | null;
  setIsAuthenticated: (value: boolean) => void;
}

const Navbar: React.FC<NavbarProps> = ({ isAuthenticated, user, setIsAuthenticated }) => {
  const navigate = useNavigate();

  const handleSignOut = () => {
    authService.logout();
    setIsAuthenticated(false);
    navigate('/');
  };

  return (
    <nav className="navbar">
      <div className="container">
        <div className="nav-content">
          <Link to="/" className="logo">
            <span className="logo-icon">✓</span>
            <span className="logo-text">FidHub</span>
          </Link>

          <div className="nav-links">
            <Link to="/" className="nav-link">Restaurantes</Link>
            {isAuthenticated && (
              <>
                <Link to="/my-points" className="nav-link">Meus Pontos</Link>
                <Link to="/submit-points" className="nav-link btn-submit">
                  + Cadastrar Pontos
                </Link>
                <Link to="/profile" className="user-avatar">
                  {user?.username?.charAt(0).toUpperCase() || 'U'}
                </Link>
                <button className="btn-signout" onClick={handleSignOut}>
                  Sair
                </button>
              </>
            )}
            {!isAuthenticated && (
              <Link to="/login" className="btn-login">
                Entrar
              </Link>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;

